import { axios } from "../../../lib/axios";
import { CategoryListResponse } from "../types";

export const GetCategory = async (): Promise<CategoryListResponse> => {
  const response = await axios.get(`/category`);
  // console.log(response.data);

  return response.data;
};
